import { render, staticRenderFns } from "./PrivacyTab.vue?vue&type=template&id=262ebd4a&scoped=true&"
import script from "./PrivacyTab.vue?vue&type=script&lang=js&"
export * from "./PrivacyTab.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTab.vue?vue&type=style&index=0&id=262ebd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ebd4a",
  null
  
)

export default component.exports